import script from "./CouponUserCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponUserCardModal.vue?vue&type=script&setup=true&lang=js"

import "./CouponUserCardModal.vue?vue&type=style&index=0&id=8fb6b4c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fb6b4c6"]])

export default __exports__